import React from "react";
import ESIInclude from "@JohnLewisPartnership/jl-esi-components";
import esiSourceWrapper from "@/constants/esiSourceWrapper";
import styles from "./screens.module.scss";
import Timeline from "@/components/timeline/Timeline";

const steps = [
  "It can take <strong>up to 7 days</strong> for your item to reach our returns centre.",
  "When we receive your item, we will check and process it. Typically this takes up to <strong>up to 2 days</strong>, but it depends on how many returns we have. We will then send you a Return Processed email.",
  "You can expect to get your refund <strong>within 5 days</strong> of receiving the Return Processed email."
];

const SolutionRefund = ({ uptoLabel, esiSource, showTimeline }) => {
  return (
    <div>
      <div className={styles.landingPageSolutionContainer}>
        <div className={styles.refundSubtitleContainer}>
          <p className={styles.refundSubtitle}>
            Your refund could take <strong>up to {uptoLabel}.</strong>
          </p>
          {showTimeline && (
            <p className={styles.textLeft}>How the process works:</p>
          )}
          {showTimeline && (
            <div className={styles.timelineContainer}>
              <Timeline steps={steps} />
            </div>
          )}
        </div>
        <div className={styles.contentContainer}>
          {esiSource && (
            <ESIInclude src={esiSourceWrapper(esiSource)} id="content" />
          )}
        </div>
      </div>
    </div>
  );
};

export default SolutionRefund;
